import {ObjectMappingKind, objectMappingKinds} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<ObjectMappingKind>;

export const ObjectMappingKindSelect = (props: Props) => {
  const {options = objectMappingKinds, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
